/* "See more" for long PDP descriptions (owner 2026-10-09).
   The text always stays in the DOM; the clamp (.is-clamped) is only applied after measuring, so without
   JavaScript the full description shows. The button is added only when the
   content really overflows, measured in the browser because line count depends on screen width.
   A closed accordion has no height yet, so measuring waits until it opens. */
(function () {
  function setup(el) {
    if (el.dataset.seeMoreReady || el.offsetParent === null) return;
    el.dataset.seeMoreReady = '1';
    var limit = parseFloat(getComputedStyle(el).getPropertyValue('--drip-clamp')) *
      parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (!limit || el.scrollHeight <= limit + 4) return;
    el.classList.add('is-clamped');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'drip-see-more__button link';
    btn.setAttribute('aria-expanded', 'false');
    if (el.id) btn.setAttribute('aria-controls', el.id);
    btn.textContent = el.dataset.more || 'See more';
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? el.dataset.less || 'See less' : el.dataset.more || 'See more';
      if (!open) el.closest('details').scrollIntoView({ block: 'nearest' });
    });
    el.insertAdjacentElement('afterend', btn);
  }
  function run() {
    document.querySelectorAll('.drip-see-more').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('toggle', function (e) {
    if (e.target.tagName === 'DETAILS' && e.target.open) run();
  }, true);
})();
